import React from 'react';
import '../less';
import List from '../views/list.c';
import WesternUnion from '../views/westernUnion.c';
import RIA from '../views/ria-new.c';
// import Welsend from '../views/welsend.c';
import Swift from '../views/swift-new.c';
import Moneygram from '../views/moneygram-new.c';
import TransferByPhone from '../TransferByPhone/views/main.c';
import IntelExpress from '../views/intelExpress-new.c';
import Sepa from '../views/sepa-new.c';
import P2Pcrossborder from "../P2Pcrossborder";
import Payoneer from '../views/payoneer.c';
// import Remitbee from '../views/remitbee.c';
import Globus from '../views/globus.c';
import NotFoundComponent from '../../../../NotFound';

export default function template() {
    const { match = {} } = this.props;
    const { params = {} } = match;

    const type =
        params.type === 'transfers'
            ? params.secondType
            : params.type;

    if (!type) {
        return (
            <List {...this.props} />
        );
    }

    let Component;

    switch (type) {
        case 'wu':
            Component = WesternUnion;
            break;
        case 'ria':
            Component = RIA;
            break;
        // case 'welsend':
        //     Component = Welsend;
        //     break;
        case 'swift':
            Component = Swift;
            break;
        case 'moneygram':
            Component = Moneygram;
            break;
        case 'sepa':
            Component = Sepa;
            break;
        case 'intel-express':
            Component = IntelExpress;
            break;
        case 'payoneer':
            Component = Payoneer;
            break;
        // case 'remitbee':
        //     Component = Remitbee;
        //     break;
        case 'globus':
            Component = Globus;
            break;
        case 'transfer_by_phone':
            Component = TransferByPhone;
            break;
        case 'P2Pcrossborder':
            Component = P2Pcrossborder;
            break;
        default:
            return (
                <NotFoundComponent
                    {...this.props}
                    route="/services/transfers"
                />
            );
    }

    return (
        <div>
            <Component {...this.props} />
        </div>
    );
}
